<template>
  <div class="home-announcement-list">
    <div class="container">
      <!-- Header Tabs -->
      <div class="list-header">
        <div class="tabs">
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'purchase' }"
            @click="activeTab = 'purchase'"
          >
            招标公告
          </button>
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'correction' }"
            @click="activeTab = 'correction'"
          >
            更正公告
          </button>
        </div>
        <span class="view-more" @click="handleMore">
          查看更多 <a-icon type="right" class="icon" />
        </span>
      </div>

      <!-- List Content -->
      <div class="list-content">
        <div
          v-for="item in currentList"
          :key="item.id"
          class="list-item"
          @click="handleItemClick(item)"
        >
          <div class="item-left">
            <span class="dot"></span>
            <p class="item-title">{{ item.title }}</p>
          </div>
          <span class="item-date">{{ $moment(item.date).format('YYYY-MM-DD HH:mm') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticeList } from '@/api/common';

export default {
  name: "HomeAnnouncementList",
  data() {
    return {
      activeTab: "purchase",
      purchaseList: [],
      correctionList: [],
      loading: false
    };
  },
  computed: {
    currentList() {
      if (this.activeTab === 'purchase') return this.purchaseList;
      return this.correctionList;
    },
  },
  watch: {
    activeTab: {
      handler(val) {
        this.fetchData(val);
      },
      immediate: true
    }
  },
  methods: {
    fetchData(tab) {
      const type = tab === 'correction' ? 2 : 1;
      const params = {
        Key: '',
        type: type,
        IncludeAuction: type === 1,
        CurrentPage: 1,
        ItemsPerPage: 8 // Assuming we want to show 8 items
      };
      
      this.loading = true;
      getNoticeList(params).then(res => {
        if (res && res.items) {
          const list = res.items.map(item => ({
            id: item.id,
            title: item.title,
            date: item.createdDate,
            isAuction: item.isAuction
          }));
          
          if (tab === 'purchase') {
            this.purchaseList = list;
          } else {
            this.correctionList = list;
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleMore() {
      let type = this.activeTab == "correction" ? 2 : 1;
      this.$router.push({ path: "/procurement-info", query: { type: type } });
    },
    handleItemClick(item) {
      this.$router.push({ path: item.isAuction ? '/auction-detail' : '/procurement-detail', query: { id: item.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.home-announcement-list {
  width: 100%;
  margin-bottom: 100px;
  .container {
    width: 1200px;
    margin: auto;
  }

  .list-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f3f4f6; // border-gray-100
    margin-bottom: 24px;

    .tabs {
      display: flex;
      gap: 32px; // space-x-8

      .tab-btn {
        font-size: 22px; // text-lg
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 11px;
        border-bottom: 4px solid transparent;
        background: none;
        border-top: none;
        border-left: none;
        border-right: none;
        // border-bottom:4px solid #5772C3;
        cursor: pointer;
        font-weight: 500;
        transition: all 0.3s;
        color: #000000; // text-gray-600

        &:hover {
          color: #5772c3; // text-blue-500
        }

        &.active {
          border-bottom-color: #5772c3; // border-blue-600
          color: #5772c3; // text-blue-600
        }
      }
    }

    .view-more {
      color: #9ca3af; // text-gray-400
      font-size: 14px;
      display: flex;
      align-items: center;
      text-decoration: none;
      transition: color 0.3s;
      cursor: pointer;
      &:hover {
        color: #5772c3; // text-blue-600
      }

      .icon {
        margin-left: 4px;
        font-size: 14px;
      }
    }
  }

  .list-content {
    display: flex;
    flex-direction: column;
    gap: 16px; // space-y-4

    .list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 4px 0;

      &:hover {
        .item-left {
          .dot {
            transform: scale(1.25);
          }

          .item-title {
            color: #5772c3; // text-blue-600
          }
        }
      }

      .item-left {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;

        .dot {
          width: 6px;
          height: 6px;
          background-color: #5772c3; // bg-blue-500
          border-radius: 50%;
          margin-right: 12px;
          flex-shrink: 0;
          transition: transform 0.3s;
        }

        .item-title {
          color: #4b5563; // text-gray-600
          font-size: 14px;

          @media (min-width: 640px) {
            font-size: 16px;
          }

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: color 0.3s;
          margin: 0;
        }

      }

      .item-date {
        color: #9197a9; // text-gray-400
        font-size: 15px;
        margin-left: 16px;
        font-family: monospace;
        flex-shrink: 0;
      }
    }
  }
}
</style>
